import * as React from "react";
import type { SVGProps } from "react";
const SvgPointer01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m10.263 14.002 2.234 6.46c.419 1.212 2.117 1.252 2.592.063l6.409-16.018c.445-1.115-.642-2.23-1.767-1.812L3.302 8.797c-1.2.446-1.203 2.143-.004 2.593z"
    />
  </svg>
);
export default SvgPointer01;
